import { useLocalization, Tooltip } from '@magicdoorinc/ui';
import IconLayout from '~/assets/images/common/layout.svg?component-solid';
import { useCustomLayout } from '~/contexts/global';
export const CustomLayoutButton = () => {
  const { t } = useLocalization();

  const { enable, startEditing, cancelEditing } = useCustomLayout();

  return (
    <Tooltip message={t('Instrument panel layout')} align="bottom">
      <button
        type="button"
        aria-pressed={enable()}
        onClick={() => {
          if (enable()) cancelEditing();
          else startEditing();
        }}
        class="invisible flex size-7 cursor-pointer items-center justify-center hover:rounded-md hover:bg-[#E9E9E9] lg:visible">
        <IconLayout />
      </button>
    </Tooltip>
  );
};
